import { MainService } from "src/app/api/main.service";

export default abstract class ApiService {

    //#region Propiedades

    public service: MainService

    //#endregion

    //#region Constructor

    constructor(service: MainService) {
        this.service = service
    }

    //#endregion

}